import {ActionTree} from "vuex";
import {RootState} from "../types/RootState";
import {StageState} from "../types/StageState";
import { State as StateStageEnum } from "@share/program/types/StageState";
import Vue from 'vue';

export const actions: ActionTree<StageState, RootState> = {
    leave({ state }) {
        state.state = state.sessionsForAnnonce.length > 1 ? StateStageEnum.activeMultiple : StateStageEnum.idling;
    },
    setState({ commit }, state: StateStageEnum) {
        commit("setState", state)
    },
    setSessionsForAnnonce({ commit }, state: any[]) {
        commit("setSessionsForAnnonce", state)
    },
    setUpcomingSessions({ commit }, state: any[]) {
        commit("setUpcomingSessions", state)
    },
    setSessionForAnnonceIsClosed({state}, id: string) {
        const session = state.sessionsForAnnonce.find((session) => session.id === id)

        if(session) {
            Vue.set(session, 'isClosed', true);
        }
    }
};